import React, { CSSProperties, forwardRef } from 'react'

import { Button } from '@chakra-ui/react'

import {
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from '../../ui/dialog'

export type ConfirmationDialogProps = {
  isOpen?: boolean
  title: string
  description?: string
  confirmingActionText: string
  onClose: () => void
  onConfirm: () => void
  children?: React.ReactNode
  isConfirmable?: boolean
  whiteSpace?: CSSProperties['whiteSpace']
}

const ConfirmationDialog = forwardRef<HTMLDivElement, ConfirmationDialogProps>(
  (
    {
      isOpen = true,
      title,
      description,
      confirmingActionText,
      onClose,
      onConfirm,
      children,
      isConfirmable = true,
      whiteSpace = 'normal',
    },
    ref,
  ) => {
    const cancelRef = React.useRef(null)

    const confirmationHandler = () => {
      onConfirm()
      onClose()
    }
    return (
      <DialogRoot
        open={isOpen}
        role="alertdialog"
        onOpenChange={(e) => {
          if (!e.open) {
            onClose()
          }
        }}
      >
        <DialogContent ref={ref} aria-label="confirmation-dialog">
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
          </DialogHeader>
          {description && (
            <DialogBody whiteSpace={whiteSpace}>{description}</DialogBody>
          )}
          {children && (
            <DialogBody whiteSpace={whiteSpace}>{children}</DialogBody>
          )}
          <DialogFooter>
            <Button ref={cancelRef} variant="subtle" onClick={onClose}>
              Cancel
            </Button>
            <Button
              colorPalette="red"
              disabled={!isConfirmable}
              ml={3}
              onClick={confirmationHandler}
            >
              {confirmingActionText}
            </Button>
          </DialogFooter>
        </DialogContent>
      </DialogRoot>
    )
  },
)

ConfirmationDialog.displayName = 'ConfirmationDialog'

export default ConfirmationDialog
